import useTestId from '@ori/testid-generator';
import { useMemo, type FC } from 'react';

import { boldMatchedText } from '../../../../utils';
import { SEARCH_PREVIEW_SUGGESTION } from './constants';
import { Label, SearchIcon, StyledChip } from './styles';
import type { SearchPreviewSuggestionProps } from './types';

export const SearchPreviewSuggestion: FC<SearchPreviewSuggestionProps> = ({ searchPhrase, text, onClick }) => {
  const { getTestId } = useTestId();

  const label = useMemo(() => {
    const textWithBoldPhrase = boldMatchedText({ searchPhrase, text });

    return <Label color="textPrimary">{textWithBoldPhrase}</Label>;
  }, [searchPhrase, text]);

  const icon = useMemo(() => <SearchIcon />, []);

  return (
    <StyledChip
      variant="rounded"
      data-testid={getTestId(SEARCH_PREVIEW_SUGGESTION)}
      label={label}
      icon={icon}
      onClick={onClick}
    />
  );
};
